import { Component, OnInit } from '@angular/core';
import { ReportsService } from '../services/reports/reports.service';
import { MessageHandlerService } from '../services/message-handler.service';
import {DEFAULT_REPORT_DOWNLOAD_LOCKED_MESSAGE, FORBIDDEN, FORBIDDEN_MESSAGE} from '../common/Constants';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-report-verification',
  templateUrl: './report-verification.component.html',
  styleUrls: ['./report-verification.component.scss'],
})
export class ReportVerificationComponent implements OnInit {
  isLoading = true;
  isAllowed = false;
  password = '';
  code = '';
  reportName = 'report';
  default_message = DEFAULT_REPORT_DOWNLOAD_LOCKED_MESSAGE;
  hasSubmittedSuccessfully = false;

  constructor(
    private reportsService: ReportsService,
    private messageHandlerService: MessageHandlerService,
  ) {}

  ngOnInit(): void {
    const params = new URLSearchParams(window.location.search);
    const rawCode = params.get('code') || '';
    this.code = rawCode.replace(/ /g, '+');
    this.reportsService.validateReportLink(this.code).subscribe({
      next: (res) => {
        this.isAllowed = !!res?.success;
        if (res?.success && (res as any).data?.reportName) {
          this.reportName = (res as any).data.reportName;
        }
        this.isLoading = false;
      },
      error: (err) => {
        this.default_message = FORBIDDEN_MESSAGE;
        this.isAllowed = false;
        this.isLoading = false;
      },
    });
  }

  submit(): void {
    if (!this.password) {
      this.messageHandlerService.generateToastMessage(
        'error',
        'Required',
        'Password is required',
      );
      return;
    }
    this.isLoading = true;
    this.reportsService
      .downloadReportWithCode({ password: this.password, code: this.code })
      .subscribe({
        next: (res: any) => {
          this.isLoading = false;
          if (res?.success && res?.content?.url) {
            const link = document.createElement('a');
            link.href = res.content.url;

            link.download = this.reportName;
            link.target = '_blank';
            link.click();
            this.hasSubmittedSuccessfully = true;
          } else {
            this.messageHandlerService.generateToastMessage(
              'error',
              'Download Failed',
              res?.message || 'Unable to download file',
            );
          }
        },
        error: (err) => {
          this.isAllowed = false;
          this.isLoading = false;
        },
      });
  }
}
